import { GapChaseFilterBase, filterType, dataType } from '../../GapChaseFilterBase';
import Axios from 'axios';

export default class Tier2RaGainFilter extends GapChaseFilterBase {
    constructor() {
        super();
        this.id = 46;
        this.name = "Tier 2 RA Gain";
        this.filterName = "Tier2RaGain";
        //this.isHidden = false;
        this.filterType = filterType.range;
        this.values = [];

        this.dataType = dataType.number;
        this.filterCategory = "Provider Level";
        this.filterGroupId = 4;
        this.minValue = -999.99;
        this.maxValue = 999.99;
        this.step = 0.01;
        this.placeholder = "Min RA Gain";

    }

}
